import React from 'react'
import { Label } from './'
import { BUSINESS_GRID } from '../../../../lib/constants'

const BusinessHeader = () => {
	return (
		<>
			<div>
				<Label>Business</Label>
				<Label>City</Label>
				<Label>Name</Label>
				<Label>Industry</Label>
				<Label>Links</Label>
			</div>
			<style jsx>{`
				div {
					width: 100%;
					padding-bottom: 0.625rem;
					border-bottom: 2px solid black;
					display: grid;
					grid-template-columns: ${BUSINESS_GRID};
				}

				@media (pointer: coarse) and (max-width: 1025px) {
					div {
						display: none;
					}
				}
			`}</style>
		</>
	)
}

export default BusinessHeader
